(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["members-gate"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    // NOT a stub. Sets the cookie the Step 8 gate check reads, then lets the
    // anchor navigate on its own — no preventDefault, so keyboard activation
    // and middle-click behave normally, and a JS failure still navigates.
    if (target.closest('[data-omygo-gate-login]')) {
      document.cookie = 'omygo_gate_passed=1; max-age=600; path=/; samesite=lax';
      return;
    }

  });

  // The sheet controller deliberately lives in assets/omygo-gate-sheets.js so a
  // harness can load it. The login cookie handler above stays inline: it is the
  // Step 8 unblock, and it should not depend on a separate file resolving.

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["omygo-collection"]) return;
  try {
    
  /*
   * Enhancement only. Everything below already works without it: the drawer
   * opens on :target and the category list is a details element. This adds
   * what a fragment link cannot do.
   *
   *   - The drawer opens and closes by class instead of by #fragment, so
   *     closing it does not scroll the page to the grid's top.
   *   - Focus moves into the drawer on open and back to the button on close.
   *   - Escape closes the drawer or the list, and a tap outside closes the
   *     list.
   *   - The list folds back down on close rather than vanishing.
   */
  (function () {
    var panel = document.querySelector('[data-coll-panel]');
    var cats = document.querySelector('[data-coll-cats]');
    if (!panel && !cats) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var opener = null;

    function openPanel(trigger) {
      opener = trigger;
      panel.classList.add('is-open');
      var close = panel.querySelector('.omy-coll__close');
      if (close) close.focus({ preventScroll: true });
    }

    function closePanel() {
      panel.classList.remove('is-open');
      if (opener) opener.focus({ preventScroll: true });
      opener = null;
    }

    function closeCats(immediately) {
      if (!cats || !cats.open || cats.hasAttribute('data-closing')) return;
      if (immediately || reduce) {
        cats.open = false;
        return;
      }
      cats.setAttribute('data-closing', '');
      var finished = false;
      function done() {
        if (finished) return;
        finished = true;
        cats.removeAttribute('data-closing');
        cats.open = false;
      }
      cats.querySelector('.omy-coll__cat-list').addEventListener('animationend', done, { once: true });
      setTimeout(done, 320);
    }

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      if (panel) {
        var open = target.closest('[data-coll-open]');
        if (open) {
          event.preventDefault();
          closeCats(true);
          openPanel(open);
          return;
        }
        // Reached by :target instead — a deep link, or a tap before this ran.
        // The class is not set, so let the link navigate as it would anyway.
        if (target.closest('[data-coll-close]') && panel.classList.contains('is-open')) {
          event.preventDefault();
          closePanel();
          return;
        }
      }

      if (cats && cats.open) {
        // A tap on the pill while open: fold down rather than snap shut.
        var summary = target.closest('.omy-coll__cat-pill');
        if (summary && cats.contains(summary)) {
          event.preventDefault();
          closeCats(false);
          return;
        }
        if (!cats.contains(target)) closeCats(false);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (panel && panel.classList.contains('is-open')) {
        closePanel();
      } else if (cats && cats.open) {
        closeCats(false);
        cats.querySelector('summary').focus();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["omygo-media-hero"] && !Shopify.designMode) return;
  try {
    
  /* Respect reduced motion: an autoplaying background video is motion. */
  (function () {
    if (!window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('.omy-mhero video').forEach(function (video) {
      video.removeAttribute('autoplay');
      video.pause();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
